import { render } from "./SkillItem.vue?vue&type=template&id=e737b934"
import script from "./SkillItem.vue?vue&type=script&lang=js"
export * from "./SkillItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__